
//load modules
import Map from '../common/Map';
import * as mapConfig from './homepage-map-config.json';

// Init modules
const map = new Map(jQuery, '#homepage-map', mapConfig);

/*#######################
### Window load event ###
#######################*/
jQuery(window).load(function () {
  map.setupMap();
});
